var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { MarkdownMessage } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/ChatWidget";
import { Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";
import { ToolCallMessage } from "./ToolCallMessage";
import { AuthenticateCallMessage } from "./AuthenticateCallMessage";
import { PromptSuggestionButton } from "./PromptSuggestionButton";
import { ErrorMessage } from "./ErrorMessage";
import { fetchPromptSuggestions } from "../api";
import { LoaderDots } from "./LoaderDots";
import { ArrowDown } from "lucide-react";
export var ChatMessages = function (_a) {
    var messages = _a.messages, isLoading = _a.isLoading, onSuggestionClick = _a.onSuggestionClick, onSuggestionSend = _a.onSuggestionSend, onAuthenticateConnect = _a.onAuthenticateConnect, _b = _a.isCompactMode, isCompactMode = _b === void 0 ? false : _b, authToken = _a.authToken, apiBaseURL = _a.apiBaseURL, selectedToolPack = _a.selectedToolPack;
    var messagesEndRef = useRef(null);
    var messagesContainerRef = useRef(null);
    var scrollContainerRef = useRef(null);
    var _c = useState([]), promptSuggestions = _c[0], setPromptSuggestions = _c[1];
    var _d = useState(true), isLoadingSuggestions = _d[0], setIsLoadingSuggestions = _d[1];
    // Track if user has manually scrolled up
    var isUserNearBottomRef = useRef(true);
    var _e = useState(false), showScrollButton = _e[0], setShowScrollButton = _e[1];
    var lastScrollTimeRef = useRef(0);
    var lastUserScrollTimeRef = useRef(0);
    var scrollThrottleMs = 100; // Throttle auto-scroll to max once per 100ms
    var userScrollGracePeriodMs = 1000; // Don't auto-scroll for 1s after user manually scrolls
    // Fetch connectors and build prompt suggestions
    useEffect(function () {
        // Don't fetch if we don't have the required data
        if (!authToken || !apiBaseURL || !selectedToolPack) {
            return;
        }
        var loadSuggestions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, suggestions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoadingSuggestions(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, fetchPromptSuggestions(apiBaseURL, authToken, selectedToolPack.id)];
                    case 2:
                        data = _a.sent();
                        suggestions = data.map(function (s) {
                            var _a, _b;
                            return ({
                                connectorSlug: (_b = (_a = s.connector) === null || _a === void 0 ? void 0 : _a.slug) !== null && _b !== void 0 ? _b : "",
                                text: s.text,
                                connector: s.connector
                                    ? {
                                        id: s.connector.id,
                                        name: s.connector.name,
                                        slug: s.connector.slug,
                                        description: "",
                                        logo_url: s.connector.logo_url,
                                        is_enabled: !s.is_disabled,
                                    }
                                    : undefined,
                                isDisabled: s.is_disabled,
                            });
                        });
                        setPromptSuggestions(suggestions);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error loading prompt suggestions:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoadingSuggestions(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        loadSuggestions();
    }, [authToken, apiBaseURL, selectedToolPack]);
    // Check if user is near the bottom of the scroll container
    var checkIfNearBottom = function () {
        var container = scrollContainerRef.current;
        if (!container)
            return true;
        var threshold = 100; // pixels from bottom
        var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, clientHeight = container.clientHeight;
        var distanceFromBottom = scrollHeight - scrollTop - clientHeight;
        return distanceFromBottom <= threshold;
    };
    // Handle scroll events to detect user scrolling
    var handleScroll = function () {
        var isNearBottom = checkIfNearBottom();
        var wasNearBottom = isUserNearBottomRef.current;
        isUserNearBottomRef.current = isNearBottom;
        setShowScrollButton(!isNearBottom);
        // If user scrolled away from bottom, record the time
        if (wasNearBottom && !isNearBottom) {
            lastUserScrollTimeRef.current = Date.now();
        }
    };
    // Scroll to bottom only if user is already near bottom
    var scrollToBottom = function (force, smooth) {
        var _a;
        if (force === void 0) { force = false; }
        if (smooth === void 0) { smooth = true; }
        var now = Date.now();
        // Throttle auto-scrolls to prevent fighting with user scroll
        if (!force) {
            if (now - lastScrollTimeRef.current < scrollThrottleMs) {
                return; // Skip this scroll, too soon after last one
            }
            // Give user a grace period after they manually scroll up
            if (now - lastUserScrollTimeRef.current < userScrollGracePeriodMs) {
                return; // User just scrolled, don't interrupt them
            }
            lastScrollTimeRef.current = now;
        }
        if (force || isUserNearBottomRef.current) {
            (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior: smooth ? "smooth" : "auto",
            });
            setShowScrollButton(false);
        }
    };
    // Handle manual scroll to bottom button click
    var handleScrollToBottomClick = function () {
        isUserNearBottomRef.current = true;
        scrollToBottom(true);
    };
    // Auto-scroll on new messages or loading state changes
    useEffect(function () {
        scrollToBottom();
    }, [messages, isLoading]);
    // Use ResizeObserver to detect content height changes (e.g., tool call status updates)
    useEffect(function () {
        var container = messagesContainerRef.current;
        if (!container)
            return;
        var timeoutId;
        var resizeObserver = new ResizeObserver(function () {
            // Debounce resize-triggered scrolls to reduce jank during fast streaming
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                // Use instant scroll for resize events to avoid animation lag
                scrollToBottom(false, false);
            }, 50);
        });
        resizeObserver.observe(container);
        return function () {
            clearTimeout(timeoutId);
            resizeObserver.disconnect();
        };
    }, []);
    return (_jsxs("div", __assign({ className: "relative flex flex-col w-full flex-1 min-h-0" }, { children: [_jsx("div", __assign({ ref: scrollContainerRef, onScroll: handleScroll, className: clsx("w-full", isCompactMode ? "h-auto" : "flex-1 overflow-y-auto pr-4") }, { children: _jsxs("div", __assign({ ref: messagesContainerRef, className: "flex flex-col gap-y-6" }, { children: [messages.length === 0 &&
                            !isLoading &&
                            (isLoadingSuggestions || promptSuggestions.length > 0) && (_jsx("div", __assign({ className: "grid grid-cols-3 w-full gap-3" }, { children: isLoadingSuggestions
                                ? // Skeleton loaders - show 3 by default while loading
                                    Array.from({ length: 3 }).map(function (_, index) { return (_jsx(PromptSuggestionButton, { isLoading: true }, "skeleton-".concat(index))); })
                                : // Actual prompt suggestions (filtered to match tool pack, max 3)
                                    promptSuggestions.map(function (suggestion, index) { return (_jsx("div", __assign({ "data-tour-id": index === 1 ? "playground-second-prompt" : undefined, className: "[&>*]:w-full [&>*]:block" }, { children: _jsx(PromptSuggestionButton, { suggestion: suggestion, onClick: onSuggestionClick, onSuggestionSend: onSuggestionSend }) }), index)); }) }))), messages.map(function (message) { return (_jsxs("div", __assign({ className: "flex flex-col gap-3" }, { children: [message.role === "user" && message.content && (_jsx("div", __assign({ className: "flex w-full justify-end" }, { children: _jsx("div", __assign({ className: "max-w-[65%] bg-gray-0 rounded-xl p-3" }, { children: _jsx(Text, __assign({ className: "whitespace-pre-wrap break-words" }, { children: message.content })) })) }))), message.role === "assistant" && message.parts && (_jsx(_Fragment, { children: message.parts.map(function (part, index) {
                                        if (part.type === "text") {
                                            return (_jsx("div", __assign({ className: "flex w-full justify-start" }, { children: _jsx("div", __assign({ className: "w-[65%]" }, { children: _jsx(MarkdownMessage, { text: part.content }) })) }), index));
                                        }
                                        if (part.type === "toolCall") {
                                            return (_jsx(ToolCallMessage, { toolCall: part.toolCall }, part.toolCall.call_id));
                                        }
                                        if (part.type === "authenticateCall") {
                                            return (_jsx(AuthenticateCallMessage, { connector: part.authenticateCall.connector, linkToken: part.authenticateCall.linkToken, onConnect: onAuthenticateConnect, isConnected: part.authenticateCall.isConnected }, part.authenticateCall.call_id));
                                        }
                                        if (part.type === "error") {
                                            return (_jsx(ErrorMessage, { message: part.message, onRetry: part.onRetry }, index));
                                        }
                                        return null;
                                    }) }))] }), message.id)); }), isLoading && _jsx(LoaderDots, {}), _jsx("div", { ref: messagesEndRef })] })) })), !isCompactMode && (_jsx("button", __assign({ onClick: handleScrollToBottomClick, className: "absolute bottom-2 left-1/2 transform -translate-x-1/2 bg-white border border-gray-10 rounded-full p-3 shadow-lg hover:shadow-xl transition-all duration-300 ease-in-out z-10 ".concat(showScrollButton
                    ? 'opacity-100 translate-y-0 scale-100'
                    : 'opacity-0 translate-y-2 scale-95 pointer-events-none'), "aria-label": "Scroll to bottom" }, { children: _jsx(ArrowDown, { size: 16 }) })))] })));
};
